import app from '@/app.js'

const state = {
    isLoaded: false,
    comps: [],
    systems: [],
    scomps: [],
    terms: [],
    termdets: [],
    opers: [],
}

const getters = {
    isLoaded: state => {
        return state.isLoaded;
    },
    systems: state => {
        return state.systems;
    },
    termdets: state => {
        return state.termdets;
    },
    opers: state => {
        return state.opers;
    },
    operations: state => {
        return state.opers;
    },
    subcompanies: state => {
        return state.scomps;
    },
    companies: state => {
        return state.comps;
    },
    terminals: state => {
        return state.terms;
    },
    companyById: state => {
        return (id) => {
            try {
                return state.comps.find(e => e.value == id);
            } catch (e) {
                console.log(e.message)
            }
            return {};
        }
    },
    systemById: state => {
        return (id) => {
            try {
                return state.systems.find(e => e.value == id);
            } catch (e) {
                console.log(e.message)
            }
            return {};
        }
    },
    systemByCard: state => {
        return (card) => {
            try {
                return state.systems.find(e => card.startsWith(e.bin));
            } catch (e) {
                console.log(e.message)
            }
            return {};
        }
    },
    systemByBin: state => {
        return (bin) => {
            try {
                return state.systems.find(e => e.bin == bin);
            } catch (e) {
                console.log(e.message)
            }
            return {};
        }
    },
    operationById: state => {
        return (id) => {
            try {
                return state.opers.find(e => e.value == id);
            } catch (e) {
                console.log(e.message)
            }
            return {};
        }
    },
    subCompanyById: state => {
        return (id) => {
            try {
                return state.scomps.find(e => e.value == id);
            } catch (e) {
                console.log(e.message)
            }
            return {};
        }
    },
}

const actions = {
    LOAD_STRUCT: (context) => {
        return new Promise((resolve, reject) => {
            app.loadStruct()
                .then(response => {
                    context.commit('SET_STRUCT', response);
                    resolve(response);
                }).catch(error => {
                    context.commit('clean');
                    reject(error);
                })
        });
    }
}

const mutations = {
    SET_STRUCT: (state, payload) => {
        function add(name) {
            try {
                state[name] = [];
                if (!payload[name]) return;
                payload[name].sort((a, b) => {
                    try {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                    } catch (e) {
                        console.error(e);
                    }
                    return 0;
                }).forEach(e => {
                    const el = {
                        value: e.id,
                        text: e.name,
                        disabled: e.status != 100,
                        idx: e.id
                    };
                    if (e.bin) el.bin = e.bin;
                    state[name].push(el);
                });
            } catch (e) {
                console.log(name, e.message);
            }
        }
        add('systems');
        add('termdets');
        add('terms');
        add('opers');
        add('scomps');
        add('comps');
        state.isLoaded = true;
    },
    clean: (state) => {
        state.isLoaded = false;
        state.comps = [];
        state.systems = [];
        state.scomps = [];
        state.terms = [];
        state.termdets = [];
        state.opers = [];
    },
}

const structura = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default structura;